import React from 'react';
import { Card, Grid, Typography, CardContent, CardMedia, CardActionArea } from "@mui/material";
import SmsTrackingReport from '../SmsManagmentReports';
import SmsTemplateTrackingReport from '../SmsManagmentReports/SmsTemplateTrackingReport';
import image from 'src/assets/images/konsep_2.jpg'

const styles = {
  rootCard: {
    maxWidth: 345
  },
  root: (theme) => ({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 2)
  }),
  media: (theme) => ({
    height: 140,
    padding: theme.spacing(6, 2)
  })
};





function SmsReporting() {

  const [reportType, setReportType] = React.useState(0);


  return (
    <Grid>
      {reportType === 0 ?
        <Grid container spacing={1} sx={styles.root}>
          <Grid
            xm={12}
            size={{
              xs: 12,
              md: 2,
              xl: 3
            }} />
          <Grid
            xm={12}
            size={{
              xs: 12,
              md: 4,
              xl: 3
            }}>
            <Card
              sx={styles.rootCard}
              onClick={() => { setReportType(1); }}
            >
              <CardActionArea>
                <CardMedia
                  sx={styles.media}
                  image={image}
                  title="Rapor"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Sms Gönderim Raporu
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    Sms Gönderim Takip raporunu incelemek için lütfen tıklayınız.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid
            xm={12}
            size={{
              xs: 12,
              md: 4,
              xl: 3
            }}>
            <Card
              sx={styles.rootCard}
              onClick={() => { setReportType(2); }}
            >
              <CardActionArea>
                <CardMedia
                  sx={styles.media}
                  image={image}
                  title="Sms Şablon Takip Raporu"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Sms Şablon Takip Raporu
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    Sms Şablon Takip raporunu incelemek için lütfen tıklayınız.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid
            xm={12}
            size={{
              xs: 12,
              md: 2,
              xl: 3
            }} />
        </Grid>
        :
        null
      }
      {reportType === 1 ?
        <SmsTrackingReport onClick={() => setReportType(0)} />
        :
        reportType === 2 ?
          <SmsTemplateTrackingReport onClick={() => setReportType(0)} /> : null
      }
    </Grid>
  );
}

export default SmsReporting;